import React from "react"

import { Form } from "@atos6/ui"
import { useStore } from "../containers"
import { InputDocumentStateful } from "./InputDocumentStateful"

export function FormItemDocumentStateful() {
  const { documentType, errors } = useStore()
  var errorProps = {}
  if (errors.documentValue) {
    errorProps = {
      hasFeedback: true,
      validateStatus: "error",
      help: errors.documentValue
    }
  }

  return (
    <Form.Item label={documentType.toUpperCase()} {...errorProps}>
      <InputDocumentStateful />
    </Form.Item>
  )
}
